export enum AsteriskKinds {
  None = 0,
  Asterisk = 1,
  BlackCircle = 2,
}
